import React, { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Space,
} from "antd";

import { BotType } from "types/bot-types";
import { create, get, update } from "services/bot.service";

import styles from "./style.module.scss";

const BotForm: React.FC = () => {
  const { code } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [saving, setSaving] = useState<boolean>(false);
  const [isCreate, setCreate] = useState<boolean>(false);

  useEffect(() => {
    const initForm = async () => {
      const bots: BotType[] = await get({ code });
      if (bots && bots.length >= 1) {
        form.setFieldsValue({ ...bots[0] });
      }
    };

    if (!!code) {
      initForm();
    }

    setCreate(!code);

    return () => form.resetFields();
  }, [form, code]);

  const onSubmit = async () => {
    try {
      setSaving(true);
      const values = await form.validateFields();
      const newValues = {
        ...values,
        code,
      };
      if (!isCreate) {
        await update(newValues);
      } else {
        await create(newValues);
      }
      message.success(`Bot ${values?.["name"]} is saved successfully`);
      isCreate && navigate("/bot/list");
    } catch (ex: any) {
      if (ex?.response?.data?.message) {
        message.error(ex?.response?.data?.message);
      } else {
        message.error("Bot is saved failed");
      }
    } finally {
      setSaving(false);
    }
  };

  const goBack = () => {
    navigate("/bot/list");
  };

  return (
    <>
      <div className="layout-content">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            <Card bordered={false} className="criclebox">
              <Form
                layout="horizontal"
                className="row-col"
                form={form}
                labelCol={{ span: 2 }}
                wrapperCol={{ xs: 24, md: 9 }}
              >
                <Form.Item
                  className="name"
                  label="Bot Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input bot name!",
                    },
                  ]}
                >
                  <Input placeholder="Bot Name" suffix="Bot" />
                </Form.Item>
                <Form.Item
                  className="apiAi"
                  label="URI"
                  name="apiAi"
                  rules={[
                    {
                      required: true,
                      message: "Please input your URI!",
                    },
                    {
                      type: "url",
                      message: "This field must be a valid url.",
                    },
                  ]}
                >
                  <Input placeholder="URI" />
                </Form.Item>
                <Form.Item
                  className="waitingTime"
                  label="Waiting Time"
                  name="waitingTime"
                  rules={[
                    {
                      required: true,
                      message: "Please input your waiting time!",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    placeholder="Waiting Time"
                    className={styles.fullWidthInput}
                  />
                </Form.Item>
                <Form.Item
                  className="aiAuthToken"
                  label="Auth Token"
                  name="aiAuthToken"
                >
                  <Input placeholder="Auth Token" />
                </Form.Item>
                <Space>
                  <Button type="primary" onClick={onSubmit} loading={saving}>
                    Save
                  </Button>
                  <Button onClick={goBack} loading={saving}>
                    Back
                  </Button>
                </Space>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BotForm;
